<script>
  import GlossaryLink from "./GlossaryLink.svelte";

  export let href;
  export let text;
</script>

<GlossaryLink {href} {text} figCaptionSize="sm" />
